import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Container, Row, Col, Modal, ModalBody, ModalHeader, ModalFooter, Button, Input, InputGroup, InputGroupText } from 'reactstrap';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import { DataGrid } from '@mui/x-data-grid';

import * as actions from '../actions/Trainings';

import LookupDropDown from '../components/common/LookupDropDown';

import GridHeader from '../components/common/GridHeader';

import DeleteConfirmation from '../components/MultiDeleteConfirmation';

const Dashboard = (props) => {
    const [deleteConfirmationState, setDeleteConfirmationState] = useState({
        display: false,
        toDelete: [],
    });
    const [deleteEnabled, setDeleteEnabled] = useState(false);
    const [showAdvancedSearchModal, setShowAdvancedSearchModal] = useState(false);

    useEffect(() => {
        props.actions.getTrainings(props.currentSessionId);
    }, [props.currentSessionId]);

    const handleSelect = (e) => {
        props.actions.getTraining(e.id);
        props.history.push(`/trainings/training/${e.id}`, { id: e.id });
    };

    const handleAddClick = (e) => {
        props.actions.newTraining();
        props.history.push({
            pathname: `/trainings/training`
        });
    }

    const handleSelectionChanged = (e) => {
        if (e.length > 0) {
            setDeleteConfirmationState({
                display: false,
                toDelete: props.trainings.filter(x => e.find(y => y === x.get('trainingId'))).toJS(),
            });
            setDeleteEnabled(true);
        }
        else
            setDeleteEnabled(false);
    }

    const handleDeleteClick = (e) => {
        setDeleteConfirmationState({
            display: true,
            toDelete: deleteConfirmationState.toDelete
        });
    }

    const handleDeleteConfirmationToggle = () => setDeleteConfirmationState({
        display: !deleteConfirmationState.display,
        toDelete: deleteConfirmationState.toDelete
    });

    const handleDelete = () => {
        props.actions.deleteTrainings(deleteConfirmationState.toDelete.map(x => x.trainingId), props.currentSessionId);
        setDeleteConfirmationState({
            display: false,
            toDelete: [],
        });
    }

    // setSearchCriteria = () => {
    //     //Not implemented yet.
    // }

    const handleToggleAdvancedSearchModal = () => setShowAdvancedSearchModal({ showAdvancedSearchModal: !showAdvancedSearchModal });


    return (
        <Container>
            {/* <Modal isOpen={this.state.showAdvancedSearchModal} toggle={this.handleToggleAdvancedSearchModal} size='lg' >
                    <ModalHeader toggle={this.handleToggleAdvancedSearch}>Advanced Search Options</ModalHeader>
                    <ModalBody>
                        <Row className='mb-5'>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>City:</InputGroupText>
                                    <Input
                                        name='city'
                                        onChange={this.setSearchCritieria}
                                        value={props.criteria.get('city') || ''}
                                    >
                                    </Input>
                                </InputGroup>
                            </Col>
                            <Col>
                                <LookupDropDown
                                    label='State'
                                    idSelector='stateId'
                                    nameSelector='name'
                                    name='state'
                                    onChange={this.setSearchCriteria}
                                    dropdownPlaceholder='Select'
                                    lookups={props.states}
                                    value={props.criteria.get('stateId') || 0}
                                    inline={true}
                                />
                            </Col>

                        </Row>
                        <Row>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>Training Types:</InputGroupText>
                                    <div className='form-control p-0 m-0'>
                                        <MultiSelect
                                            className='form-control'
                                            options={props.trainingTypes}
                                            value={props.criteria.get('selectedTrainingTypes')}
                                            onChange={props.actions.updateSelectedTrainingTypes}
                                        />
                                    </div>
                                </InputGroup>
                            </Col>
                            <Col>
                                <InputGroup>
                                    <InputGroupText>Programs:</InputGroupText>
                                    <div className='form-control p-0 m-0'>
                                        <MultiSelect
                                            className='form-control'
                                            options={props.programs}
                                            value={props.criteria.get('selectedPrograms')}
                                            onChange={props.actions.updateSelectedPrograms}
                                        />
                                    </div>
                                </InputGroup>
                            </Col>
                        </Row>

                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.handleSearch}>Search</Button>{' '}
                        <Button color="secondary" onClick={props.actions.clearAdvancedSearchCriteria}>Clear</Button>
                        <Button color="secondary" onClick={this.handleToggleAdvancedSearchModal}>Cancel</Button>
                    </ModalFooter>
                </Modal> */}

            <Row className='mb-1'>

                <GridHeader
                    gridEntities='Trainings'
                    deleteButtonId='deleteTrainingButton'
                    disableDelete={!deleteEnabled}
                    onDeleteClick={handleDeleteClick}
                    addButtonId='addTrainingButton'
                    searchButtonId='searchTrainingsButton'
                    onAddClick={handleAddClick}
                    tooltipEntity={'Training'}
                    showSearch={false}
                    onSearch={handleToggleAdvancedSearchModal}
                />
            </Row>
            <Row className='mb-1'>
                <Col>
                    <DataGrid
                        rows={props.trainings.toJS().map(x => { return { id: x.trainingId, ...x } })}
                        checkboxSelection
                        onRowDoubleClick={(e) => handleSelect(e)}
                        onRowSelectionModelChange={handleSelectionChanged}
                        autoHeight={true}
                        rowHeight={35}
                        initialState={{
                            pagination: { paginationModel: { pageSize: 25 } },
                        }}
                        columns={[
                            {
                                headerName: 'Project',
                                field: 'projectName',
                                flex: 3,
                            },
                            {
                                headerName: 'Training',
                                field: 'trainingType',
                                flex: 1,
                            },
                            {
                                headerName: 'City',
                                field: 'city',
                                flex: 1,
                            },
                            {
                                headerName: 'State',
                                field: 'state',
                                flex: 1,
                            },
                            {
                                headerName: 'Location Type',
                                field: 'trainingLocation',
                                flex: 1,
                            },
                            {
                                headerName: 'Start Date',
                                field: 'startDate',
                                valueGetter: ({ value }) => value && new Date(value),
                                flex: 1,
                                type: 'date'
                            },
                            {
                                headerName: 'End Date',
                                field: 'endDate',
                                valueGetter: ({ value }) => value && new Date(value),
                                flex: 1,
                                type: 'date'
                            },
                            {
                                headerName: 'Time Zone',
                                field: 'timeZone',
                                flex: 1,
                            }

                        ]}
                        sx={{
                            backgroundColor: 'white'
                        }}
                        getRowClassName={(params) => 'grid-row'}
                    />

                </Col>
            </Row>
            <DeleteConfirmation
                style={{ width: 700 }}
                title={`Delete Training`}
                onDelete={handleDelete}
                onToggle={handleDeleteConfirmationToggle}
                toDelete={deleteConfirmationState.toDelete.map(x => `${x.projectName}-${x.trainingType} ${moment(x.startDate).format("DD/MM/YYYY")} to ${moment(x.endDate).format("DD/MM/YYYY")}`)}
                isOpen={deleteConfirmationState.display}
            />
        </Container>
    );

}

function mapStateToProps(state, ownProps) {
    return {
        trainings: state.Trainings.get('list'),
        criteria: state.Trainings.get('criteria'),
        programs: state.PickLists.get('programs').toJS(),
        trainingTypes: state.PickLists.get('trainingTypes').toJS()
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...actions,
        }, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);